/**
 * Utility function for merging class names with Tailwind CSS
 * 
 * Provides a type-safe way to conditionally apply class names
 * and merge them with Tailwind's utility classes.
 */
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merges multiple class values into a single className string
 * 
 * @param {...ClassValue[]} inputs - Class values to merge
 * @returns {string} Merged className string with Tailwind conflicts resolved
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
